import { render } from "./modalBoxes.vue?vue&type=template&id=04d10584&scoped=true"
import script from "./modalBoxes.vue?vue&type=script&lang=js"
export * from "./modalBoxes.vue?vue&type=script&lang=js"

import "./modalBoxes.vue?vue&type=style&index=0&id=04d10584&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d10584"]])

export default __exports__